<template>
  <div>
    <div>
      <div class="lyon-display-medium-24 mb-3 mt-3">
        Current and Future Committee Membership
      </div>
      <div v-if="committees.current_or_future.length === 0">
        <span class="text-muted regular-14">No result</span>
      </div>
      <div v-for="(member, index) in committees.current_or_future" v-else :key="index">
        <b-card :class="index%2 === 1 ? 'bg-shade-2 mb-2' : 'bg-shade-1 mb-2'">
          <div class="row align-items-center">
            <div class="col-xs-4 col-sm-6 col-lg-6">
              <div class="medium-16 text-muted mb-2">{{ member.office }}</div>
              <div class="bold-21">{{ member.name }}</div>
            </div>
            <div class="col-xs-4 col-sm-2 col-lg-2">
              <div class="regular-12 text-muted">Date</div>
            </div>
            <div v-if="!checkIfEmeritiTrusteesCommitteeSelected(member.name)" class="regular-12 col-xs-4 col-sm-4 col-lg-4">
              <span>{{ moment(member.start_date, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY') }}</span>
              <span> - </span>
              <span>{{ moment(member.end_date, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY') }}</span>
            </div>
            <div v-else class="regular-12 col-xs-4 col-sm-4 col-lg-4"> -- </div>
          </div>
        </b-card>
      </div>
    </div>
    <div>
      <div class="lyon-display-medium-24 mb-3 mt-3">
        Past Committee Membership
      </div>
      <div v-if="committees.past.length === 0">
        <span class="text-muted regular-14">No result</span>
      </div>
      <div v-for="(member, index) in committees.past" v-else :key="index">
        <b-card :class="index%2 === 1 ? 'bg-shade-2 mb-2' : 'bg-shade-1 mb-2'">
          <div class="row align-items-center">
            <div class="col-xs-4 col-sm-6 col-lg-6">
              <div class="medium-16 text-muted mb-2">{{ member.office }}</div>
              <div class="bold-21">{{ member.name }}</div>
            </div>
            <div class="col-xs-4 col-sm-2 col-lg-2">
              <div class="regular-12 text-muted">Date</div>
            </div>
            <div class="regular-12 col-xs-4 col-sm-4 col-lg-4">
              <span>{{ moment(member.start_date, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY') }}</span>
              <span> - </span>
              <span>{{ moment(member.end_date, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY') }}</span>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "@/utils/mixin.js"

export default {
	name: "CommitteesTab",
	mixins: [mixin],
	props: ["committees"],
	data() {
		return {
			search: "",
			sort: "alphabetically",
			options: [{ text: "Alphabetically", value: "alphabetically" }],
		}
	},
}
</script>
